import { Anchor, CollectionError, Flex, Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

export function ErrorPage() {
  return (
    <div
      className={csx({
        position: 'absolute',
        top: 0,
        size: '100%',
        background: '$secondary',
        borderRadius: 'default',
        padding: '$space-4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      <Flex
        direction="column"
        align="center"
        className={csx({ '>*': { paddingBottom: '$space-4' } })}
      >
        <CollectionError />

        <Text variant="pageTitle">
          <FormattedMessage id="admin/promotions.error.generic" />
        </Text>

        <Text>
          <FormattedMessage
            id="admin/promotions.error.generic.action"
            values={{
              b: (content) => (
                <Anchor href="" onClick={() => window.top?.location.reload()}>
                  {content}
                </Anchor>
              ),
            }}
          />
        </Text>
      </Flex>
    </div>
  )
}
